import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import * as yup from "yup";

export interface IServiceCodeFormMeta {
    
    // Service Code
    first: FormInputMeta;
    second: FormInputMeta;
    third: FormInputMeta;
}
const serviceCodeFormMeta = {} as IServiceCodeFormMeta;

// Service Code Form Fields
serviceCodeFormMeta.first = {
    name: "first",
    type: "select",
    label: "Premier",
    placeholder: "",
    validation: yup.number().required("Champ obligatoire !")
};

serviceCodeFormMeta.second = {
    name: "second",
    type: "select",
    label: "Deuxième",
    placeholder: "",
    validation: yup.number().required("Champ obligatoire !")
};

serviceCodeFormMeta.third = {
    name: "third",
    type: "select",
    label: "Troisième",
    placeholder: "",
    validation: yup.number().required("Champ obligatoire !")
};

export default serviceCodeFormMeta;